import React, { FC, useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import FormContext from '../FormContext';
import { FormComposedProps } from './Form';

const withFormContext = <Values, >(WrappedComponent: FC<FormComposedProps<Values>>) => hoistNonReactStatics((props: FormComposedProps<Values>) => {
  const { isolate } = props;

  const {
    ancestorFormId, parentFormId, formScope,
    registerForm, unregisterForm, valuesDst, ancestorValuesDst, ancestorCommitFormValues, ancestorCommitFormState,
    formReducerKey, disabled, readOnly, textOnly, ancestorFormReducerScope, ancestorFormReducerKey, hideErrorMessages, hideHoistedAnchor, hideErrorHoistedAnchor, hideWarningHoistedAnchor, hideCautionHoistedAnchor,
  } = useContext(FormContext);

  if (!isolate && ancestorFormId) {
    return (
      <WrappedComponent
        ancestorFormId={ancestorFormId}
        parentFormId={parentFormId}
        parentFormScope={formScope}
        parentFormReducerKey={formReducerKey}
        registerForm={registerForm}
        unregisterForm={unregisterForm}
        ancestorValuesDst={ancestorValuesDst}
        ancestorFormReducerKey={ancestorFormReducerKey}
        ancestorCommitFormValues={ancestorCommitFormValues}
        ancestorCommitFormState={ancestorCommitFormState}
        ancestorFormReducerScope={ancestorFormReducerScope}
        hideErrorMessages={hideErrorMessages}
        hideHoistedAnchor={hideHoistedAnchor}
        hideErrorHoistedAnchor={hideErrorHoistedAnchor}
        hideWarningHoistedAnchor={hideWarningHoistedAnchor}
        hideCautionHoistedAnchor={hideCautionHoistedAnchor}
        disabled={disabled}
        readOnly={readOnly}
        textOnly={textOnly}
        {...props}
        valuesDst={valuesDst}

      />
    );
  }
  return (
    <WrappedComponent
      isolatedSubForm={Boolean(isolate && ancestorFormId)}
      {...props}
      originalValuesDst={props.valuesDst}
    />
  );
}, WrappedComponent);

export default withFormContext;
